<template>
  <div class="app-footer">
    <app-navigation
      :class="[
        'controls',
        currentConfig.bottomNavigationPosition
      ]"
      @navigate-button="$emit('navigate-button', $event)"
      @show-menu="$emit('show-menu')"
      @select-language="$emit('select-language', $event)"
      @restart-flow="$emit('restart-flow')"
    >
      <close-website-button
        v-if="isWebsite && !isNotFullsizeWebsite"
        class="close-website-button"
      />
    </app-navigation>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import useConfig from '@/composables/useConfig';
import useWebsite from '@/composables/useWebsite';
import CloseWebsiteButton from '@/components/CloseWebsiteButton.vue';
import AppNavigation from '@/components/AppNavigation.vue';

export default defineComponent({
  name: 'AppFooterComponent',

  emits: ['show-menu', 'restart-flow', 'select-language', 'navigate-button'],

  components: {
    AppNavigation,
    CloseWebsiteButton,
  },

  setup() {
    const {
      currentConfig,
    } = useConfig();
    const { isWebsite, isNotFullsizeWebsite } = useWebsite();

    return {
      currentConfig,
      isWebsite,
      isNotFullsizeWebsite,
    };
  },
});
</script>

<style lang="scss" scoped>
.app-footer {
  padding: 10px 16px;
  height: 64px;
  z-index: 4;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
  display: flex;

  @media screen and (max-width: $desktop_s_breakpoint - 1px) {
    background-color: #fff;
    position: sticky;
  }

  @media screen and (max-height: $mobile_height_breakpoint) {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
  }

  @media screen and (min-height: $big_vertical_screen_breakpoint) {
    height: 188px;
    padding: 20px 40px;
    background-color: #fff;
  }
}

.close-website-button {
  position: static;
}

.controls {
  z-index: 10000;
  &.center {
    justify-content: center;
  }

  &.left {
    justify-content: flex-start;
  }

  &.right {
    justify-content: flex-end;
  }
}
</style>
